var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-builder"},[_c('PartLeft'),_c('SResizeBox',{attrs:{"default-width":"70vw"}},[_c('PartCenter')],1),_c('PartRight',{ref:"partRight"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }